import { IconVariant } from '@/components/icons/types';
import { _t } from '@/locale';

const baseTranslationKey = 'features.deals.pages.DealsLanding.constants' as const;
/**
 * Keyword shorcut Pills for Deals landing page
 */
export const DEALS_KEYWORD_SEARCH_SHORTCUTS: Array<{ slug: string; icon: IconVariant; value: string }> = [
  { slug: 'frisor', icon: 'barber-scissors', value: _t(`${baseTranslationKey}.DEALS_KEYWORD_SEARCH_SHORTCUTS.frisor`) },
  { slug: 'massage', icon: 'massage', value: _t(`${baseTranslationKey}.DEALS_KEYWORD_SEARCH_SHORTCUTS.massage`) },
  { slug: 'naglar', icon: 'nails', value: _t(`${baseTranslationKey}.DEALS_KEYWORD_SEARCH_SHORTCUTS.naglar`) },
  { slug: 'fransar', icon: 'lashes', value: _t(`${baseTranslationKey}.DEALS_KEYWORD_SEARCH_SHORTCUTS.fransar`) },
  { slug: 'hudvard', icon: 'skincare', value: _t(`${baseTranslationKey}.DEALS_KEYWORD_SEARCH_SHORTCUTS.hudvard`) },
];
